<template>
  <GoogleMap
    map-id="ccp_map"
    :zoom="17"
    :api-promise="apiPromise"
    :center="center"
    :zoom-control="false"
    :street-view-control="false"
    :map-type-control="false"
  >
    <AdvancedMarker
      v-if="!!center"
      :options="markerOptions"
      :pin-options="pinOptions"
      @dragend="markerDragend"
    />
  </GoogleMap>
</template>

<script setup>
import { GoogleMap, AdvancedMarker } from 'vue3-google-map';
import { Loader } from '@googlemaps/js-api-loader';

const loader = new Loader( {
    apiKey: import.meta.env.TWC_GOOGLE_MAPS_KEY,
    version: 'weekly',
} );

const apiPromise = new Promise( async ( resolve ) => {
    await Promise.all( [
        loader.importLibrary( 'places' ),
        loader.importLibrary( 'marker' ),
        loader.importLibrary( 'geocoding' ),
    ] );
    resolve( window.google );
} );
</script>

<script>
export default {
    components: {
        GoogleMap,
        AdvancedMarker,
    },
    props: {
        centerLatitude: {
            type: Number,
            required: false,
            default: null,
        },
        centerLongitude: {
            type: Number,
            required: false,
            default: null,
        },
    },
    data() {
        return {
            pinOptions: {},
        };
    },
    computed: {
        markerOptions() {
            return {
                position: this.center,
                gmpDraggable: true,
            };
        },
        center() {
            if ( !this.$props.centerLatitude || !this.$props.centerLongitude ) {
                return {};
            }

            return {
                lat: this.$props.centerLatitude,
                lng: this.$props.centerLongitude,
            };
        },
    },
    methods: {
        markerDragend( event ) {
            this.$emit( 'markerDragend', event );
        },
    },
};
</script>
